<template>
  <b-dropdown
    :disabled="this.disabled"
    :text="csize"
    variant="outline-primary"
    class="font-size"
  >
    <b-dropdown-item
      v-for="size in this.fontSizes"
      :key="size"
      :active="size === csize"
      :style="[{ fontFamily: 'Arial', fontSize: '11px' }]"
      @click.prevent="fontSizeSelected(size)"
      >{{ size }}</b-dropdown-item
    >
  </b-dropdown>
</template>

<script>
import {fontSizes} from '../../../config/constanteUse'
import { ActionType } from './actionType'
export default {
  props: {
    fontSize: {
      type: String,
      default: '11'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      actionType: ActionType.FONT_SIZE,
      fontSizes,
      csize: '11'
    }
  },
  mounted () {
    this.csize = this.fontSize
  },
  methods: {
    fontSizeSelected (value) {
      this.csize = value
      this.$emit('change', this.actionType, value)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/ui/fontSizeUI.vue